import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useI18n } from '../context/i18nContext';
import Button from '../components/ui/Button';
import '../styles/AuthPages.css';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useI18n();

  const token = searchParams.get('token');

  const [password, setPassword]     = useState('');
  const [confirm, setConfirm]       = useState('');
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState('');
  const [success, setSuccess]       = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirm) {
      setError(t('auth.validation.passwordMismatch'));
      return;
    }
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(password)) {
      setError(t('auth.validation.passwordTooWeak'));
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
        setTimeout(() => navigate('/login'), 3000);
      } else {
        setError(data.error || t('password.resetFailed'));
      }
    } catch {
      setError(t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-page-container">
        <div className="auth-card">
          <p className="auth-message error">❌ {t('password.resetFailed')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page-container">
      <div className="auth-card">
        <div className="auth-logo">🔑</div>
        <h1 className="auth-title">{t('password.resetTitle')}</h1>
        <p className="auth-subtitle">{t('password.resetSubtitle')}</p>

        {success ? (
          <p className="auth-message success">✅ {t('password.resetSuccess')}</p>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            {error && <p className="auth-message error">❌ {error}</p>}

            <div className="form-group">
              <label>{t('password.newPassword')}</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoFocus
              />
              <small className="form-hint">{t('auth.validation.passwordRequirements')}</small>
            </div>

            <div className="form-group">
              <label>{t('password.confirmNewPassword')}</label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
              />
            </div>

            <Button type="submit" variant="solid" fullWidth disabled={loading}>
              {loading ? t('password.resetSaving') : t('password.resetButton')}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
